<script>
	import {positionX, positionY, dimensionX, dimensionY} from './store.js'; //* as store //$store.thing // see: `Svelte - Tweened store (motion)`, by Svelte Mastery: youtube.com/channel/UCg6SQd5jnWo5Y70rZD9SQFA: youtube.com/watch?v=b9AtOa_iKhE
	export let bg = 'bg-gold';// Pass slot argument: youtu.be/-tYrLmzMsWE?t=164
	export let destinations;
	export let pointOfInterest;
	export let terra;
	export let track;
	export let connections;
</script>

	<!-- preserveAspectRatio="xMidYMid meet": https://slides.com/sarasoueidan/styling-animating-svgs-with-css#/38  -->
	<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="{$positionX} {$positionY} {$dimensionX} {$dimensionY}"
	xml:space="preserve"
	class="
	w-100 vh-50
	w-50-ns vh-75-ns
	w-50-m vh-100-m
	w-50-l vh-100-l
	"
	style="
	pointer-event:none;
	background: linear-gradient(
		180deg,
			{bg} 0vw,
			{bg} 78vw,
			#BCDFF7 78vw,
			#BCDFF7 100vw
		);"
	>


	<!--
		style="background-color:{bg};"
		<?xml version="1.0" encoding="utf-8"?> -->
	<!--
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	-->

	<defs data-type="organisation-only">

		<path
			id="track"
			pathLength="0.99"
			d="M656.8,599.4c-60.3-49.8-43-72.5-82.1-81.6c-3.5-1.3-5.5-3.1-9.1-5.7c-16-13.4-15.2-20.5-34.6-25.3
				c-59.4-10.5-98.4-63-158.8-61.9"></path>
		<mask id="mask">
			<use
				xlink:href="#track"
				stroke-width="4"
				stroke="white"
				fill="none"
			>
			</use>
		</mask>


		{#each connections as connection }
			<symbol id={connection.name}>
				<path d={connection.path}/>
			</symbol>
			<pattern
				id="{connection.name}_dash"
				width="100%"
				height="100%"
				patternUnits="userSpaceOnUse"
			>
				<use
					xlink:href="#{connection.name}"
					class={connection.color}
					stroke="currentColor"
					stroke-width="2"
					stroke-dasharray="4"
					stroke-dashoffset="4"
				/>
			</pattern>
		{/each}



		{#each destinations as destination }
			<symbol id={destination.name}>
				<path d={destination.path}/>
			</symbol>
			<pattern
				id="{destination.name}_dash"
				width="100%"
				height="100%"
				patternUnits="userSpaceOnUse"
			>
				<use
					xlink:href="#{destination.name}"
					class={destination.color}
					stroke="currentColor"
					stroke-width="2"
					stroke-dasharray="4"
					stroke-dashoffset="4"
				/>
			</pattern>
		{/each}
	</defs>

	{#each terra as earth }
	<path
	id={earth.name||''}
	fill={earth.fill||'none'}
	stroke={earth.stroke||'none'}
	stroke-width={earth.strokeWidth||'0'}
	d={earth.path}/>
	{/each}


	{#each connections as connection }
	<path
		d={ connection.path }
		class="{ connection.class } { connection.visibility ? "draw" : "undraw" }"
		data-comment="CSS transition `trigger` IntersectionObserver draw/hide"
		fill="none"
		stroke-width="0"
		pathLength="1"
		stroke-dasharray="1"
		stroke={connection.stroke}
		/>
	{/each}









	{#each destinations as destination }
	<path
		d={ destination.path }
		class="{ destination.class } { destination.visibility ? "draw" : "undraw" }"
		data-comment="CSS transition `trigger` IntersectionObserver draw/hide"
		fill="none"
		stroke-width="0"
		pathLength="1"
		stroke-dasharray="1"
		stroke={destination.stroke}
		/>
	<!--
		style="
		transition: stroke-dashoffset
			{destination.distance/2}s
			{destination.distance/4}s ease-out;
		-webkit-transition: stroke-dashoffset
			{destination.distance/2}s
			{destination.distance/4}s ease-out;
		"
	-->
	<!-- stroke={destination.stroke} || stroke="url(#{destination.name}_dash)" -->
	{/each}



	{#each pointOfInterest as poi }
	<!--
		--NOTE: complte example: `strTest = strTest.replace(re, "");`
			- from: https://stackoverflow.com/questions/2670037/how-to-remove-invalid-utf-8-characters-from-a-javascript-string
	-->
	<a
		href='#{poi.name}'
		xlink:href="#{poi.name.toLowerCase().replace(/\s/g, '')}"
		class="pointer ttu">
	<text
		text-anchor={
			poi.anchor === 'start' ? 'start' :
			poi.anchor === 'end' ? 'end' : 'middle'
		}
		transform='translate({
				poi.anchor === 'start' ? poi.x-(-14) :
				poi.anchor === 'end' ? poi.x-14 : poi.x
			}
			{
				poi.anchor === 'start' ? poi.y-(-5) :
				poi.anchor === 'end' ? poi.y-(-5) : poi.y-14
			})'
	>{poi.name}</text>
		<circle
			class="poi"
			cx={poi.x}
			cy={poi.y}
			r="8"
		/>
	</a>
	{/each}


	<rect
	id="safe-frame"
	fill="none"
	x="300"
	y="320"
	width="444"
	height="444"
	/>

	<rect
	id="safe-frame"
	fill="none"
	x="256"
	y="256"
	width="512"
	height="512"
	/>
		<!--
		class="debug"
		fill="#FFDA00"
		fill-opacity="0.4" -->


{#each track as t }
<!-- icon: loco -->
<path
	d="M13.6,20.2c0.6,0,0.5-1.8,0.6-2.4l3.6-0.1c1.9-10-3.9-3.3-1-7.7c0.8,0,2.5,0,3.3,0c0-0.5,0-2.3-0.1-2.6h-2.8
	c0-0.1,0-0.2,0-0.3c0-2-1.7-3.6-3.6-3.6c-2,0-3.6,1.7-3.6,3.6c0,0.1,0,0.2,0,0.2H8.7c0-0.1,0-0.1,0-0.2c0-2-1.7-3.6-3.6-3.6
	S1.5,5.2,1.5,7.1c0,0.1,0,0.1,0,0.2h-5c-0.7-2.1-2.8-3.7-5.2-3.7s-4.4,1.6-5.1,3.7h-4.8l-0.1,2.3l0,0l0,0c0.7,0.1,2.4,0,3.5,0.1
	c0.6,0,1.8,8-1.7,8.1c0,0.5,0,1.5,0.1,2l10.5,0.1c0.5-3.1-2.8-2.2,5.4-2.2c1.7,0,1.4,2.1,3.9,2.1c2.4,0,2-2.1,3.6-2.1
	c0.5,0,3,0,3.5,0.1c0.5,0.5-0.4,2.2,0.9,2.4H13.6z"
	class:loco={t.visibility}
	fill="azure"
	stroke="skyblue"
	stroke-width="1.5"
	></path>
	<!-- debug: the path to be animated along. RM `opacity="0"` -->
	<path
	fill="none"
	stroke-width="5"
	stroke="#006f45"
	opacity="0"
	mask="url(#mask)"
	stroke-dasharray="6"
	stroke-dashoffset="12"
	d="M656.8,599.4c-60.3-49.8-43-72.5-82.1-81.6c-3.5-1.3-5.5-3.1-9.1-5.7c-16-13.4-15.2-20.5-34.6-25.3 c-59.4-10.5-98.4-63-158.8-61.9"
/>
{/each}



	</svg>

	<style>
	/* --NOTE: `svg.viewBox` not implemented: https://www.sarasoueidan.com/blog/svg-art-direction-using-viewbox/ */
	/*
	svg {
	view: 512 512
	}*/

	path { stroke-linecap:round }
	.loco {
		offset-path: path('M656.8,599.4c-60.3-49.8-43-72.5-82.1-81.6c-3.5-1.3-5.5-3.1-9.1-5.7c-16-13.4-15.2-20.5-34.6-25.3 c-59.4-10.5-98.4-63-158.8-61.9');
		animation: move 8s ease forwards; /*infinite*/
	}
	@keyframes move { 100% { offset-distance: 100% } }

	text{
		font-weight:700;
		font-family:
			avenir next, avenir,
			sans-serif,'Avenir-Black';
		font-size:10px;
	}
	.hiking{
	/* stroke-width:6; */
	fill:none;
	stroke-linecap:round;
	stroke-linejoin:round
	}
	.poi{
	fill:black
	}
	/* rect{fill:none} */
	.debug {
	stroke:currentColor;
	stroke-width: 0.3;
	fill: none;
	fill-opacity:0;
	stroke-opacity:1;
	}


.draw {
	/* transition: stroke-dashoffset 6s ease; */
		/* -webkit-transition: stroke-dashoffset 6s ease; */
		/* stroke-width:20; */
		stroke-width:6;
		stroke-dashoffset: 0; /* `path-length: 0;` https://stackoverflow.com/questions/63793850/animate-svg-with-keyframes-on-an-elipsis-path */
		animation: draw 1.6s ease-out forwards;

		/* animation: draw 6s ease-out forwards; */

		/*animation-fill-mode:forwards*/
	/*animation: `keyframes-name duration-S timing-function delay play-state` */
}
@keyframes draw {
	from {
		stroke-width:6;
		stroke-dashoffset: 1 }
	to {
		stroke-width:6;
		stroke-dashoffset: 0;
	}
}



.undraw {
	animation: reverse 0.3s ease-out forwards; /*animation-fill-mode:forwards*/
	/*animation: `keyframes-name duration-S timing-function delay play-state` */
}
@keyframes reverse {
	from {
		stroke-width:6;
		stroke-dashoffset: 0 }
	to {
		stroke-width:6;
		stroke-dashoffset: 1;
	}
}
</style>
	<!-- <script>
	// --Note: Remember: named functions are more readable: https://youtu.be/ogXETl_I0Dg?t=2848
	//let x=0, y=0;
	function updateAnchorX(poi, value) {
			if (pointOfInterest[poi].anchor === "start") {
			poi.value-(-14)
		}	else if (pointOfInterest[poi].anchor === "end") {
			poi.value-14
		} else {
			poi.value
		}
	}
	function updateAnchorY(poi, value) {
	if (pointOfInterest[poi].anchor === "middle") {
			poi.value-(-14)
		}
	}
	// let updateX = () => {{poi.x}};
	function updateThing(poi) {
		//let result;
		if (poi.anchor === "start") {
			poi = "start"
		} else if (poi.anchor === "end") {
			poi = "end"
		} else {
			poi = "middle"
		}
	}
	</script> -->
	<!--style>
	/*
	`color: var(--` > `stroke: var(--`
	`background-color: var(--` > `fill: var(--`
	`border-color: var(--` > debug
	*/
	/*
	https://stackoverflow.com/questions/37940282/changing-the-stroke-color-for-an-inline-svg */
	path {
		fill:none;
		stroke-linecap:round;
	}
	text { fill: currentColor }
	.bounce {
		transition: all 0.6s cubic-bezier(0.68, -2.15, 0.27, 2.15);
		-webkit-transition: all 0.6s cubic-bezier(0.68, -2.15, 0.27, 2.15);
	}
	/* Transition change X to Y */
	.transition {
		transition: all 0.6s ease;
		-webkit-transition: all 0.6s ease;
	}
	.draw {
		transition: stroke-dashoffset 0.6s ease;
		-webkit-transition: stroke-dashoffset 0.6s ease;
		/* stroke-width:20; */
		stroke-width:2;
		stroke-dashoffset: 0; /* `path-length: 0;` https://stackoverflow.com/questions/63793850/animate-svg-with-keyframes-on-an-elipsis-path */
	}
	.chunky {
		fill-opacity:1;
		stroke-opacity:1;
		transform: scale(1.25);
	}
	.fill-opacity {
		fill-opacity:1;/* www.sitepoint.com/css-animation-no-javascript */
	}
	.paused {
		stroke-dashoffset: 0; /*rm: transition! */
		animation-play-state:pause;
	}
	.multistep {
		animation: multistep 2s ease-out forwards; /*animation-fill-mode:forwards*/
		/*animation: `keyframes-name duration-S timing-function delay play-state` */
	}
	@keyframes multistep {
		from { stroke-dashoffset: 1 }
		to {
			stroke-dashoffset: 0;
		}
	}
	/* This is for multi-step animation */
	.animate {
		animation: dash 2s ease-out forwards;
	}
	@keyframes dash {
		from { stroke-dashoffset: 1 }
		to { stroke-dashoffset: 0 }
	}
	</style-->